export const TransformCollaborator = Symbol.for('TransformCollaborator');
